define('views/modules/member/select/member-select-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/fetch-list',
    'views/modules/member/select/member-select-list-item',
    // collections
    'collections/member/profiles'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VFetchList,
    VMemberSelectListItem,
    // collection
    CProfiles
) {

    var VMemberSelectList = VFetchList.extend({
        item: VMemberSelectListItem,

        initialize: function(opt) {
            VMemberSelectList.__super__.initialize.apply(this, arguments);
            this.selectedCollection = new CProfiles();
            this.listenTo(this.collection, {
                'member:click': this.onMemberClick,
            });
        },

        onMemberClick: function(model, val) {
            if (val) {
                this.selectedCollection.add(model);
            } else {
                this.selectedCollection.remove(model, { silent: true });
            }
            this.triggerSelectedEvent();
        },

        reset: function() {
            this.selectedCollection.reset();
            this.$('.member-list-item').removeClass('active');
            this.triggerSelectedEvent();
        },

        selectAll: function() {
            this.selectedCollection.add(this.collection.models);
            this.$('.member-list-item').addClass('active');
            this.triggerSelectedEvent();
        },

        triggerSelectedEvent: function() {
            this.trigger('selected:change', this.selectedCollection);
        },

        getSelectedCollection: function() {
            return this.selectedCollection;
        },

        resetSelectedCollection: function() {
            return this.selectedCollection.reset();
        },
    });

    return VMemberSelectList;
});

